import { useState, useEffect } from "react";
const API = "";
const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("mb_token")}` });
const fmt = (ts) => { if (!ts) return "—"; const n = Number(ts); if (n > 1e12) return new Date(n).toISOString().slice(5,16).replace("T"," "); if (typeof ts === "string" && ts.includes("-")) return ts.slice(5,16); return ts; };
const fmtPrice = (v, d=6) => v ? Number(v).toFixed(d) : "—";
const fmtMoney = (v) => v != null ? `${v>=0?"+":""}$${Math.abs(v).toFixed(2)}` : "—";
const pc = (v) => (v||0) >= 0 ? "#00ff88" : "#ff4466";
const C = { bg:"#050810",bg2:"#080d18",bg3:"#0c1220",border:"#0e1830",border2:"#152040",accent:"#0066ff",accent2:"#0044cc",accentGlow:"rgba(0,102,255,0.15)",green:"#00ff88",greenGlow:"rgba(0,255,136,0.1)",red:"#ff4466",redGlow:"rgba(255,68,102,0.1)",yellow:"#ffaa00",text:"#e8f0ff",textMid:"#7890bb",textDim:"#3a5080",mono:"'JetBrains Mono','Fira Code','Courier New',monospace",sans:"'IBM Plex Sans','SF Pro Display',system-ui,sans-serif" };
// ── MOBILE DETECTION ─────────────────────────────────────────
function useMobile(){
  const [mobile,setMobile]=useState(window.innerWidth<768);
  useEffect(()=>{const h=()=>setMobile(window.innerWidth<768);window.addEventListener("resize",h);return()=>window.removeEventListener("resize",h);},[]);
  return mobile;
}

// ── MOBILE DASHBOARD ─────────────────────────────────────────
function MobileDashboard({stats,positions,trades,logs,status,btc,onLogout}){
  const [tab,setTab]=useState("home");
  const {cd,open}=useCountdown();
  const lc=l=>l.includes("ERROR")||l.includes("sl_hit")?"#ff4466":l.includes("tp_hit")||l.includes("✅")?"#00ff88":l.includes("SIGNAL")?"#ffaa00":C.textMid;
  const ms={
    wrap:{minHeight:"100vh",background:C.bg,fontFamily:C.mono,color:C.text,display:"flex",flexDirection:"column"},
    header:{background:C.bg2,borderBottom:`1px solid ${C.border}`,padding:"12px 16px"},
    brand:{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8},
    brandName:{fontSize:16,fontWeight:700,color:C.text,letterSpacing:3},
    pill:{fontSize:8,background:C.greenGlow,color:C.green,border:`1px solid ${C.green}44`,padding:"2px 8px",borderRadius:2,letterSpacing:1},
    metrics:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,background:C.border},
    metric:{background:C.bg2,padding:"12px 14px"},
    mlabel:{fontSize:8,color:C.textDim,letterSpacing:2,marginBottom:4},
    mval:{fontSize:20,fontWeight:700,fontFamily:C.mono},
    msub:{fontSize:9,color:C.textDim,marginTop:2},
    content:{flex:1,overflowY:"auto"},
    section:{padding:"14px 16px",borderBottom:`1px solid ${C.border}`},
    sectionTitle:{fontSize:8,color:C.textDim,letterSpacing:2,marginBottom:10},
    posCard:{background:C.bg2,border:`1px solid ${C.border}`,borderLeft:`3px solid ${C.green}`,borderRadius:"0 6px 6px 0",padding:"10px 12px",marginBottom:8},
    tradeRow:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:`1px solid ${C.border}`},
    logLine:{display:"flex",gap:8,padding:"4px 0",borderBottom:`1px solid ${C.border}08`,fontSize:10},
    bottomNav:{display:"flex",background:C.bg2,borderTop:`1px solid ${C.border}`},
    navBtn:{flex:1,padding:"12px 4px",textAlign:"center",cursor:"pointer",border:"none",background:"transparent",display:"flex",flexDirection:"column",alignItems:"center",gap:3},
  };
  return(
    <div style={ms.wrap}>
      {/* Header */}
      <div style={ms.header}>
        <div style={ms.brand}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:24,height:24,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,borderRadius:5,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <svg width="12" height="12" viewBox="0 0 20 20" fill="none"><path d="M10 2L16 6V11C16 14.5 13.5 17.5 10 19C6.5 17.5 4 14.5 4 11V6L10 2Z" stroke="white" strokeWidth="1.5" fill="none"/><circle cx="10" cy="10" r="2.5" fill="white"/></svg>
            </div>
            <span style={ms.brandName}>MOVA<span style={{color:C.accent}}>BOT</span></span>
            <span style={ms.pill}>LIVE</span>
          </div>
          <button onClick={onLogout} style={{background:"transparent",border:`1px solid ${C.border2}`,borderRadius:3,color:C.textDim,fontSize:9,fontFamily:C.mono,padding:"4px 10px",cursor:"pointer"}}>EXIT</button>
        </div>
        {/* Gate countdown */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:9,color:C.textDim}}>
          <span>BTC <b style={{color:pc(btc.change)}}>${btc.price?.toLocaleString()||"..."}</b> <span style={{color:pc(btc.change)}}>{btc.change>=0?"+":""}{btc.change}%</span></span>
          <span style={{display:"flex",alignItems:"center",gap:4}}>
            <div style={{width:5,height:5,borderRadius:"50%",background:open?C.green:C.textDim}}/>
            <span style={{color:open?C.green:C.textMid}}>{open?"GATE OPEN":"NEXT"} {cd}</span>
          </span>
        </div>
      </div>

      {/* Metrics */}
      <div style={ms.metrics}>
        {[
          {l:"EQUITY",v:`$${status.equity?.toFixed(2)||"0"}`,s:"Started $110",c:C.text},
          {l:"TOTAL PNL",v:fmtMoney(stats.total_pnl),s:`${stats.wins||0}W · ${stats.losses||0}L`,c:pc(stats.total_pnl||0)},
          {l:"WIN RATE",v:`${stats.win_rate||0}%`,s:`${stats.total_trades||0} trades`,c:C.accent},
          {l:"OPEN",v:positions.length,s:positions.length>0?"Position active":"No positions",c:positions.length>0?C.green:C.textMid},
        ].map((m,i)=>(
          <div key={i} style={ms.metric}>
            <div style={ms.mlabel}>{m.l}</div>
            <div style={{...ms.mval,color:m.c}}>{m.v}</div>
            <div style={ms.msub}>{m.s}</div>
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={ms.content}>
        {tab==="home"&&(
          <>
            {/* Open Positions */}
            <div style={ms.section}>
              <div style={ms.sectionTitle}>OPEN POSITIONS · {positions.length}</div>
              {positions.length===0?(
                <div style={{color:C.textDim,fontSize:11,textAlign:"center",padding:"16px 0"}}>No open positions</div>
              ):positions.map((p,i)=>(
                <div key={i} style={ms.posCard}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:C.text,fontSize:13,fontWeight:700}}>{p.symbol}</span>
                    <span style={{color:pc(p.pnl),fontSize:13,fontWeight:700}}>{fmtMoney(p.pnl)}</span>
                  </div>
                  <div style={{display:"flex",gap:12,fontSize:10,color:C.textDim}}>
                    <span style={{color:p.direction==="LONG"?C.green:C.red}}>{p.direction}</span>
                    <span>Entry: <b style={{color:C.textMid}}>{fmtPrice(p.entry)}</b></span>
                    <span>SL: <b style={{color:C.red}}>{fmtPrice(p.sl)}</b></span>
                  </div>
                </div>
              ))}
            </div>
            {/* Recent Trades */}
            <div style={ms.section}>
              <div style={ms.sectionTitle}>RECENT TRADES</div>
              {trades.slice(0,8).map((t,i)=>(
                <div key={i} style={ms.tradeRow}>
                  <div>
                    <div style={{fontSize:11,color:C.text,fontWeight:600}}>{t.symbol}</div>
                    <div style={{fontSize:9,color:C.textDim,marginTop:2}}>{fmt(t.open_time)}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <span style={{fontSize:9,padding:"1px 6px",borderRadius:2,background:t.direction==="LONG"?C.greenGlow:C.redGlow,color:t.direction==="LONG"?C.green:C.red,border:`1px solid ${t.direction==="LONG"?C.green+"44":C.red+"44"}`}}>{t.direction}</span>
                    <div style={{fontSize:11,color:pc(t.pnl),fontWeight:700,marginTop:2}}>{fmtMoney(t.pnl)}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {tab==="logs"&&(
          <div style={{padding:"0"}}>
            <div style={{padding:"10px 16px",borderBottom:`1px solid ${C.border}`,fontSize:8,color:C.textDim,letterSpacing:2}}>LIVE LOGS</div>
            {logs.slice().reverse().map((line,i)=>(
              <div key={i} style={{...ms.logLine,padding:"5px 16px",borderBottom:`1px solid ${C.border}08`}}>
                <span style={{color:C.textDim,flexShrink:0,minWidth:42,fontSize:9}}>{line.split("|")[0]?.trim().slice(11,16)}</span>
                <span style={{color:lc(line),fontSize:9,wordBreak:"break-all"}}>{line.split("|").slice(3).join("|").trim().slice(0,60)}</span>
              </div>
            ))}
          </div>
        )}
        {tab==="stats"&&(
          <div style={{padding:"16px"}}>
            <div style={ms.sectionTitle}>STATISTICS</div>
            {[
              {l:"Total PnL",v:fmtMoney(stats.total_pnl),c:pc(stats.total_pnl||0)},
              {l:"Win Rate",v:`${stats.win_rate||0}%`,c:C.accent},
              {l:"Total Trades",v:stats.total_trades||0,c:C.text},
              {l:"Wins",v:stats.wins||0,c:C.green},
              {l:"Losses",v:stats.losses||0,c:C.red},
              {l:"Equity",v:`$${status.equity?.toFixed(2)||"0"}`,c:C.text},
              {l:"Uptime",v:status.uptime||"...",c:C.textMid},
              {l:"Symbols",v:"12",c:C.text},
              {l:"Leverage",v:"20x",c:C.yellow},
            ].map(({l,v,c})=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${C.border}`,fontSize:12,fontFamily:C.mono}}>
                <span style={{color:C.textMid}}>{l}</span>
                <span style={{color:c,fontWeight:600}}>{v}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bottom Nav */}
      <div style={ms.bottomNav}>
        {[["home","⬡","Dashboard"],["logs","▤","Logs"],["stats","◎","Stats"]].map(([id,icon,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{...ms.navBtn,color:tab===id?C.accent:C.textDim,borderTop:`2px solid ${tab===id?C.accent:"transparent"}`}}>
            <span style={{fontSize:18}}>{icon}</span>
            <span style={{fontSize:9,letterSpacing:1}}>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}



function useCountdown(){
  const [cd,setCd]=useState("");const [open,setOpen]=useState(false);
  useEffect(()=>{ const tick=()=>{ const now=new Date();const m=now.getUTCMinutes();const s=now.getUTCSeconds(); if(m>=55){setOpen(true);const r=(59-m)*60+(60-s);setCd(`GATE OPEN · ${String(Math.floor(r/60)).padStart(2,"0")}:${String(r%60).padStart(2,"0")}`);}else{setOpen(false);const r=(55-m-1)*60+(60-s);setCd(`${String(Math.floor(r/3600)).padStart(2,"0")}:${String(Math.floor((r%3600)/60)).padStart(2,"0")}:${String(r%60).padStart(2,"0")}`);} }; tick();const i=setInterval(tick,1000);return()=>clearInterval(i); },[]);
  return{cd,open};
}


function EqChart({data,h,w,color,id}){
  if(!data||data.length<2) return <svg width="100%" height={h} viewBox={`0 0 ${w} ${h}`}/>;
  const vals=data.map(d=>d.v);
  const min=Math.min(...vals),max=Math.max(...vals),range=max-min||1;
  const pts=vals.map((v,i)=>`${(i/(vals.length-1))*w},${h-((v-min)/range)*(h*0.9)}`).join(" ");
  return(
    <svg width="100%" height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none">
      <defs><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity="0.3"/><stop offset="100%" stopColor={color} stopOpacity="0"/></linearGradient></defs>
      <polygon points={`0,${h} ${pts} ${w},${h}`} fill={`url(#${id})`}/>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5"/>
    </svg>
  );
}


function Login({onLogin}){
  const [email,setEmail]=useState("admin@movabot");const [pw,setPw]=useState("");const [err,setErr]=useState("");const [loading,setLoading]=useState(false);const [dots,setDots]=useState(0);
  useEffect(()=>{const i=setInterval(()=>setDots(d=>(d+1)%4),400);return()=>clearInterval(i);},[]);
  const submit=async(e)=>{ e.preventDefault();setLoading(true);setErr(""); try{ const form=new FormData();form.append("username",email);form.append("password",pw); const r=await fetch(`${API}/auth/login`,{method:"POST",body:form});const d=await r.json(); if(!r.ok)throw new Error(d.detail||"Auth failed"); localStorage.setItem("mb_token",d.access_token);onLogin(); }catch(e){setErr(e.message);} setLoading(false); };
  return(
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:C.mono,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`linear-gradient(${C.border} 1px,transparent 1px),linear-gradient(90deg,${C.border} 1px,transparent 1px)`,backgroundSize:"60px 60px",opacity:0.4}}/>
      <div style={{position:"absolute",top:"20%",left:"15%",width:300,height:300,background:`radial-gradient(circle,${C.accentGlow},transparent 70%)`,filter:"blur(40px)"}}/>
      <div style={{position:"absolute",bottom:"20%",right:"15%",width:200,height:200,background:"radial-gradient(circle,rgba(0,255,136,0.08),transparent 70%)",filter:"blur(40px)"}}/>
      <div style={{position:"relative",zIndex:1,width:420}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,marginBottom:8}}>
            <div style={{width:40,height:40,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",boxShadow:`0 0 20px ${C.accentGlow}`}}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2L16 6V11C16 14.5 13.5 17.5 10 19C6.5 17.5 4 14.5 4 11V6L10 2Z" stroke="white" strokeWidth="1.5" fill="none"/><circle cx="10" cy="10" r="2.5" fill="white"/></svg>
            </div>
            <span style={{fontSize:28,fontWeight:700,color:C.text,letterSpacing:6}}>MOVA<span style={{color:C.accent}}>BOT</span></span>
          </div>
          <div style={{fontSize:11,color:C.textDim,letterSpacing:4}}>AI TRADING TERMINAL v2.0</div>
          <div style={{display:"flex",justifyContent:"center",gap:16,marginTop:16}}>
            {[["AES-256",C.green],["JWT AUTH",C.accent],["TLS 1.3",C.yellow]].map(([t,c])=>(
              <div key={t} style={{fontSize:9,color:c,border:`1px solid ${c}44`,padding:"2px 10px",borderRadius:2,letterSpacing:2,background:`${c}0a`}}>{t}</div>
            ))}
          </div>
        </div>
        <div style={{background:C.bg2,border:`1px solid ${C.border2}`,borderRadius:8,overflow:"hidden",boxShadow:`0 0 40px rgba(0,102,255,0.1),0 20px 60px rgba(0,0,0,0.5)`}}>
          <div style={{height:2,background:`linear-gradient(90deg,transparent,${C.accent},transparent)`}}/>
          <div style={{padding:"32px 36px"}}>
            <form onSubmit={submit}>
              {[{l:"ACCESS ID",v:email,set:setEmail,t:"text"},{l:"MASTER KEY",v:pw,set:setPw,t:"password"}].map(({l,v,set,t})=>(
                <div key={l} style={{marginBottom:20}}>
                  <div style={{fontSize:9,color:C.textDim,letterSpacing:3,marginBottom:8}}>{l}</div>
                  <input type={t} value={v} onChange={e=>set(e.target.value)} style={{width:"100%",background:C.bg3,border:`1px solid ${C.border2}`,borderRadius:4,padding:"11px 14px",color:C.text,fontSize:13,fontFamily:C.mono,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor=C.accent} onBlur={e=>e.target.style.borderColor=C.border2}/>
                </div>
              ))}
              {err&&<div style={{color:C.red,fontSize:11,marginBottom:16,padding:"8px 12px",background:C.redGlow,border:`1px solid ${C.red}44`,borderRadius:4}}>⚠ {err}</div>}
              <button type="submit" disabled={loading} style={{width:"100%",background:loading?C.bg3:`linear-gradient(135deg,${C.accent},${C.accent2})`,border:"none",borderRadius:4,padding:13,color:"white",fontSize:12,fontFamily:C.mono,letterSpacing:3,cursor:loading?"not-allowed":"pointer"}}>
                {loading?`AUTHENTICATING${".".repeat(dots)}`:"[ AUTHENTICATE ]"}
              </button>
            </form>
          </div>
          <div style={{padding:"12px 36px",background:C.bg,borderTop:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",fontSize:9,color:C.textDim}}>
            <span>MOVABOT © 2026</span><span>MAX 3 ATTEMPTS · AUTO-LOCK</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Sidebar({page,setPage,positions}){
  const nav=[{id:"dashboard",icon:"⬡",label:"Dashboard"},{id:"trades",icon:"◈",label:"Trade History"},{id:"analytics",icon:"◎",label:"Analytics"},{id:"logs",icon:"▤",label:"System Logs"},{id:"settings",icon:"◧",label:"Bot Settings"}];
  return(
    <div style={{width:200,background:C.bg2,borderRight:`1px solid ${C.border}`,display:"flex",flexDirection:"column",flexShrink:0}}>
      <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:28,height:28,background:`linear-gradient(135deg,${C.accent},${C.accent2})`,borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M10 2L16 6V11C16 14.5 13.5 17.5 10 19C6.5 17.5 4 14.5 4 11V6L10 2Z" stroke="white" strokeWidth="1.5" fill="none"/><circle cx="10" cy="10" r="2.5" fill="white"/></svg>
        </div>
        <div><div style={{fontSize:13,fontWeight:700,color:C.text,letterSpacing:2,fontFamily:C.mono}}>MOVA<span style={{color:C.accent}}>BOT</span></div><div style={{fontSize:8,color:C.textDim,letterSpacing:1}}>TRADING TERMINAL</div></div>
      </div>
      <div style={{padding:"10px 20px",borderBottom:`1px solid ${C.border}`}}>
        <div style={{background:C.greenGlow,border:`1px solid ${C.green}44`,borderRadius:4,padding:"6px 10px",display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:6,height:6,borderRadius:"50%",background:C.green,boxShadow:`0 0 6px ${C.green}`,animation:"pulse 2s infinite"}}/>
          <div><div style={{fontSize:9,color:C.green,letterSpacing:1}}>BOT ONLINE</div><div style={{fontSize:8,color:C.textDim}}>Bybit Connected</div></div>
        </div>
      </div>
      <nav style={{flex:1,padding:"8px 0"}}>
        {nav.map(({id,icon,label})=>(
          <div key={id} onClick={()=>setPage(id)} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 20px",cursor:"pointer",borderLeft:`2px solid ${page===id?C.accent:"transparent"}`,background:page===id?C.accentGlow:"transparent",transition:"all 0.15s"}}>
            <span style={{fontSize:14,color:page===id?C.accent:C.textDim}}>{icon}</span>
            <span style={{fontSize:11,color:page===id?C.text:C.textMid,letterSpacing:1,fontFamily:C.mono}}>{label}</span>
            {id==="dashboard"&&positions.length>0&&<span style={{marginLeft:"auto",fontSize:8,background:C.green,color:C.bg,padding:"1px 5px",borderRadius:2,fontWeight:700}}>{positions.length}</span>}
          </div>
        ))}
      </nav>
      <div style={{padding:"12px 20px",borderTop:`1px solid ${C.border}`,fontSize:9,color:C.textDim,fontFamily:C.mono}}>
        <div style={{marginBottom:4}}>v2.0.0 · 12 symbols</div>
        <div>20x leverage · ICT+BRK+OF</div>
      </div>
      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}`}</style>
    </div>
  );
}

function Topbar({status,btc,stats,onLogout}){
  const {cd,open}=useCountdown();
  const [time,setTime]=useState("");
  useEffect(()=>{const t=setInterval(()=>setTime(new Date().toUTCString().slice(17,25)),1000);return()=>clearInterval(t);},[]);
  return(
    <div style={{height:40,background:C.bg,borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",padding:"0 20px",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8,padding:"0 16px",borderRight:`1px solid ${C.border}`}}>
        <span style={{fontSize:9,color:C.textDim,letterSpacing:1}}>BTC</span>
        <span style={{fontSize:11,color:C.text,fontFamily:C.mono,fontWeight:600}}>${btc.price?.toLocaleString()||"..."}</span>
        <span style={{fontSize:9,color:pc(btc.change),fontFamily:C.mono}}>{btc.change>=0?"+":""}{btc.change}%</span>
      </div>
      {[{l:"EQUITY",v:`$${status.equity?.toFixed(2)||"0"}`,c:C.text},{l:"PNL",v:fmtMoney(stats.total_pnl),c:pc(stats.total_pnl)},{l:"WIN RATE",v:`${stats.win_rate||0}%`,c:C.accent},{l:"TRADES",v:stats.total_trades||0,c:C.text}].map(({l,v,c})=>(
        <div key={l} style={{display:"flex",gap:6,padding:"0 16px",borderRight:`1px solid ${C.border}`,alignItems:"center"}}>
          <span style={{fontSize:8,color:C.textDim,letterSpacing:1}}>{l}</span>
          <span style={{fontSize:11,color:c,fontFamily:C.mono,fontWeight:600}}>{v}</span>
        </div>
      ))}
      <div style={{flex:1}}/>
      <div style={{padding:"0 16px",borderLeft:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:8}}>
        <div style={{width:6,height:6,borderRadius:"50%",background:open?C.green:C.textDim,boxShadow:open?`0 0 6px ${C.green}`:"none"}}/>
        <span style={{fontSize:9,color:open?C.green:C.textMid,fontFamily:C.mono,letterSpacing:1}}>{open?"GATE OPEN":"NEXT GATE"} {cd}</span>
      </div>
      <div style={{padding:"0 16px",borderLeft:`1px solid ${C.border}`,fontSize:9,color:C.textDim,fontFamily:C.mono}}>{time} UTC</div>
      <button onClick={onLogout} style={{marginLeft:8,padding:"4px 12px",background:"transparent",border:`1px solid ${C.border2}`,borderRadius:3,color:C.textDim,fontSize:9,fontFamily:C.mono,cursor:"pointer",letterSpacing:1}}>EXIT</button>
    </div>
  );
}

function DashboardPage({stats,positions,trades,logs,status,equityCurve,dailyPnl,symbolStats}){
  const [tab,setTab]=useState("positions");
  const symbols=["TIAUSDT","COMPUSDT","ZETAUSDT","BERAUSDT","RONINUSDT","DEEPUSDT","KITEUSDT","PORTALUSDT","GALAUSDT","PENGUUSDT","PYTHUSDT","ZORAUSDT"];
  const lc=l=>l.includes("ERROR")||l.includes("sl_hit")?"#ff4466":l.includes("tp_hit")||l.includes("✅")?"#00ff88":l.includes("SIGNAL")?"#ffaa00":C.textMid;
  const SparkLine=({data,color})=>{
    if(!data||data.length<2)return null;
    const vals=data.map(d=>d.v||0);const min=Math.min(...vals),max=Math.max(...vals),range=max-min||1;
    const pts=vals.map((v,i)=>`${(i/(vals.length-1))*80},${28-((v-min)/range)*24}`).join(" ");
    return <svg width={80} height={28}><polyline points={pts} fill="none" stroke={color} strokeWidth="1.5"/></svg>;
  };
  return(
    <div style={{flex:1,display:"grid",gridTemplateRows:"auto auto 1fr auto",gap:1,background:C.border,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,background:C.border}}>
        {[
          {l:"ACCOUNT EQUITY",v:`$${status.equity?.toFixed(2)||"0.00"}`,s:"Started $110.00",c:C.text,spark:equityCurve,sc:C.accent},
          {l:"TOTAL PNL",v:fmtMoney(stats.total_pnl),s:`${stats.wins||0} wins · ${stats.losses||0} losses`,c:pc(stats.total_pnl||0),spark:dailyPnl,sc:pc(stats.total_pnl||0)},
          {l:"WIN RATE",v:`${stats.win_rate||0}%`,s:`${stats.total_trades||0} total trades`,c:C.accent,spark:null},
          {l:"OPEN POSITIONS",v:positions.length,s:positions.length>0?positions.map(p=>p.symbol.replace("USDT","")).join(" · "):"Waiting for signal",c:positions.length>0?C.green:C.textMid,spark:null},
        ].map((m,i)=>(
          <div key={i} style={{background:C.bg2,padding:"14px 16px",display:"flex",flexDirection:"column",justifyContent:"space-between",minHeight:90}}>
            <div style={{fontSize:8,color:C.textDim,letterSpacing:2,fontFamily:C.mono}}>{m.l}</div>
            <div style={{display:"flex",alignItems:"flex-end",justifyContent:"space-between"}}>
              <div>
                <div style={{fontSize:22,fontWeight:700,color:m.c,fontFamily:C.mono,letterSpacing:-1,lineHeight:1}}>{m.v}</div>
                <div style={{fontSize:9,color:C.textDim,marginTop:4,fontFamily:C.mono}}>{m.s}</div>
              </div>
              {m.spark&&<SparkLine data={m.spark} color={m.sc}/>}
            </div>
          </div>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",gap:1,background:C.border}}>
        <div style={{background:C.bg2,padding:"12px 16px"}}>
          <div style={{fontSize:8,color:C.textDim,letterSpacing:2,marginBottom:6,fontFamily:C.mono,display:"flex",justifyContent:"space-between"}}><span>EQUITY CURVE</span><span style={{color:C.accent}}>{equityCurve.length} pts</span></div>
          <EqChart data={equityCurve} h={90} w={400} color={C.accent} id="eg"/>
        </div>
        <div style={{background:C.bg2,padding:"12px 16px"}}>
          <div style={{fontSize:8,color:C.textDim,letterSpacing:2,marginBottom:6,fontFamily:C.mono}}>DAILY PNL</div>
          <div style={{display:"flex",alignItems:"flex-end",gap:3,height:90}}>
            {dailyPnl.slice(-7).map((d,i)=>{
              const max=Math.max(...dailyPnl.map(x=>Math.abs(x.v)),1);const h=Math.max(Math.abs(d.v)/max*70,2);
              return(<div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2,justifyContent:"flex-end",height:"100%"}}>
                <div style={{fontSize:7,color:d.v>=0?C.green:C.red,fontFamily:C.mono}}>{d.v>=0?"+":""}{d.v?.toFixed(0)}</div>
                <div style={{width:"100%",height:h,background:d.v>=0?`${C.green}55`:`${C.red}55`,border:`1px solid ${d.v>=0?C.green:C.red}`,borderRadius:"2px 2px 0 0"}}/>
                <div style={{fontSize:7,color:C.textDim,fontFamily:C.mono}}>{d.d?.slice(3)}</div>
              </div>);
            })}
            {dailyPnl.length===0&&<div style={{color:C.textDim,fontSize:9,width:"100%",textAlign:"center",paddingTop:20,fontFamily:C.mono}}>No data</div>}
          </div>
        </div>
        <div style={{background:C.bg2,padding:"12px 16px"}}>
          <div style={{fontSize:8,color:C.textDim,letterSpacing:2,marginBottom:8,fontFamily:C.mono}}>SYMBOL HEATMAP</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:3}}>
            {symbols.map(sym=>{
              const ss=symbolStats.find(s=>s.s===sym);
              const bg=!ss?C.bg3:ss.pnl>5?`${C.green}33`:ss.pnl>0?`${C.green}18`:ss.pnl<-5?`${C.red}33`:`${C.red}18`;
              const border=!ss?C.border:ss.pnl>0?`${C.green}55`:`${C.red}55`;
              const tc=!ss?C.textDim:ss.pnl>0?C.green:C.red;
              return(<div key={sym} title={`${sym}: ${ss?`$${ss.pnl.toFixed(2)}`:"-"}`} style={{background:bg,border:`1px solid ${border}`,borderRadius:3,padding:"3px 2px",textAlign:"center"}}>
                <div style={{fontSize:8,color:tc,fontFamily:C.mono}}>{sym.replace("USDT","")}</div>
                {ss&&<div style={{fontSize:7,color:tc,fontFamily:C.mono}}>{ss.pnl>=0?"+":""}{ss.pnl.toFixed(1)}</div>}
              </div>);
            })}
          </div>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 260px",gap:1,background:C.border,overflow:"hidden"}}>
        <div style={{background:C.bg2,display:"flex",flexDirection:"column",overflow:"hidden"}}>
          <div style={{display:"flex",borderBottom:`1px solid ${C.border}`,flexShrink:0}}>
            {[["positions","POSITIONS"],["trades","RECENT TRADES"],["signals","SIGNALS"]].map(([id,label])=>(
              <div key={id} onClick={()=>setTab(id)} style={{padding:"8px 20px",fontSize:9,cursor:"pointer",letterSpacing:2,fontFamily:C.mono,color:tab===id?C.text:C.textDim,borderBottom:`2px solid ${tab===id?C.accent:"transparent"}`,background:tab===id?C.accentGlow:"transparent"}}>
                {label}{id==="positions"&&positions.length>0&&<span style={{marginLeft:6,background:C.green,color:C.bg,fontSize:8,padding:"1px 5px",borderRadius:2}}>{positions.length}</span>}
              </div>
            ))}
          </div>
          <div style={{flex:1,overflowY:"auto"}}>
            {tab==="positions"&&(positions.length===0?(
              <div style={{textAlign:"center",padding:32,color:C.textDim,fontSize:11,fontFamily:C.mono}}><div style={{fontSize:24,marginBottom:8}}>◎</div>No open positions · next scan at :55</div>
            ):(
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:`1px solid ${C.border}`}}>{["SYMBOL","DIR","ENTRY","SL","TP","UNREALIZED PNL","LEV","OPENED"].map(h=>(
                  <th key={h} style={{fontSize:8,color:C.textDim,textAlign:"left",padding:"8px 12px",fontWeight:400,letterSpacing:2,fontFamily:C.mono}}>{h}</th>
                ))}</tr></thead>
                <tbody>{positions.map((p,i)=>(
                  <tr key={i} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?"transparent":C.bg}}>
                    <td style={{padding:"9px 12px",color:C.text,fontFamily:C.mono,fontSize:11,fontWeight:600}}>{p.symbol}</td>
                    <td style={{padding:"9px 12px"}}><span style={{fontSize:9,padding:"2px 8px",borderRadius:2,background:p.direction==="LONG"?C.greenGlow:C.redGlow,color:p.direction==="LONG"?C.green:C.red,border:`1px solid ${p.direction==="LONG"?C.green+"44":C.red+"44"}`,fontFamily:C.mono}}>{p.direction}</span></td>
                    <td style={{padding:"9px 12px",color:C.textMid,fontFamily:C.mono,fontSize:10}}>{fmtPrice(p.entry)}</td>
                    <td style={{padding:"9px 12px",color:C.red,fontFamily:C.mono,fontSize:10}}>{fmtPrice(p.sl)}</td>
                    <td style={{padding:"9px 12px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{p.tp?fmtPrice(p.tp):"—"}</td>
                    <td style={{padding:"9px 12px",color:pc(p.pnl),fontFamily:C.mono,fontSize:11,fontWeight:600}}>{fmtMoney(p.pnl)}</td>
                    <td style={{padding:"9px 12px",color:C.yellow,fontFamily:C.mono,fontSize:10}}>{p.leverage}x</td>
                    <td style={{padding:"9px 12px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{fmt(p.open_time)}</td>
                  </tr>
                ))}</tbody>
              </table>
            ))}
            {tab==="trades"&&(
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead><tr style={{borderBottom:`1px solid ${C.border}`}}>{["SYMBOL","DIR","ENTRY","EXIT","PNL","DATE"].map(h=>(
                  <th key={h} style={{fontSize:8,color:C.textDim,textAlign:"left",padding:"8px 12px",fontWeight:400,letterSpacing:2,fontFamily:C.mono}}>{h}</th>
                ))}</tr></thead>
                <tbody>{trades.slice(0,15).map((t,i)=>(
                  <tr key={i} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?"transparent":C.bg}}>
                    <td style={{padding:"7px 12px",color:C.text,fontFamily:C.mono,fontSize:11}}>{t.symbol}</td>
                    <td style={{padding:"7px 12px"}}><span style={{fontSize:9,padding:"1px 7px",borderRadius:2,background:t.direction==="LONG"?C.greenGlow:C.redGlow,color:t.direction==="LONG"?C.green:C.red,border:`1px solid ${t.direction==="LONG"?C.green+"44":C.red+"44"}`,fontFamily:C.mono}}>{t.direction}</span></td>
                    <td style={{padding:"7px 12px",color:C.textMid,fontFamily:C.mono,fontSize:10}}>{fmtPrice(t.entry)}</td>
                    <td style={{padding:"7px 12px",color:C.textMid,fontFamily:C.mono,fontSize:10}}>{fmtPrice(t.exit)}</td>
                    <td style={{padding:"7px 12px",color:pc(t.pnl),fontFamily:C.mono,fontSize:11,fontWeight:600}}>{fmtMoney(t.pnl)}</td>
                    <td style={{padding:"7px 12px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{fmt(t.open_time)}</td>
                  </tr>
                ))}</tbody>
              </table>
            )}
            {tab==="signals"&&(
              <div style={{fontFamily:C.mono}}>
                {logs.filter(l=>l.includes("SIGNAL")||l.includes("ORDER PLACED")||l.includes("tp_hit")||l.includes("sl_hit")).slice(-20).reverse().map((line,i)=>(
                  <div key={i} style={{display:"flex",gap:12,padding:"7px 12px",borderBottom:`1px solid ${C.border}`,fontSize:10}}>
                    <span style={{color:C.textDim,minWidth:46,flexShrink:0}}>{line.split("|")[0]?.trim().slice(11,16)}</span>
                    <span style={{color:lc(line)}}>{line.split("|").slice(3).join("|").trim()}</span>
                  </div>
                ))}
                {logs.filter(l=>l.includes("SIGNAL")).length===0&&<div style={{textAlign:"center",padding:32,color:C.textDim,fontSize:11}}>No signals recently</div>}
              </div>
            )}
          </div>
        </div>
        <div style={{background:C.bg2,display:"flex",flexDirection:"column",overflow:"hidden"}}>
          <div style={{padding:"8px 12px",borderBottom:`1px solid ${C.border}`,flexShrink:0,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:8,color:C.textDim,letterSpacing:2,fontFamily:C.mono}}>LIVE LOGS</span>
            <div style={{width:6,height:6,borderRadius:"50%",background:C.green,boxShadow:`0 0 6px ${C.green}`,animation:"pulse 2s infinite"}}/>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:"4px 0"}}>
            {logs.slice().reverse().map((line,i)=>(
              <div key={i} style={{display:"flex",gap:6,padding:"2px 10px",borderBottom:`1px solid ${C.border}08`,fontSize:9,lineHeight:1.6,fontFamily:C.mono}}>
                <span style={{color:C.textDim,flexShrink:0,minWidth:38}}>{line.split("|")[0]?.trim().slice(11,16)}</span>
                <span style={{color:lc(line),wordBreak:"break-all",fontSize:9}}>{line.split("|").slice(3).join("|").trim().slice(0,40)}</span>
              </div>
            ))}
          </div>
          <div style={{padding:"8px 12px",borderTop:`1px solid ${C.border}`,fontSize:8,color:C.textDim,fontFamily:C.mono,flexShrink:0}}>
            <div>UPTIME · {status.uptime||"..."}</div>
            <div style={{marginTop:2}}>HALT · <span style={{color:C.green}}>DISABLED</span></div>
          </div>
        </div>
      </div>
      <div style={{background:C.bg,borderTop:`1px solid ${C.border}`,padding:"0 20px",display:"flex",alignItems:"center",gap:20,height:28,flexShrink:0}}>
        {[{l:"WS",v:"CONNECTED",c:C.green},{l:"BYBIT",v:"LIVE",c:C.green},{l:"WINS",v:stats.wins||0,c:C.green},{l:"LOSSES",v:stats.losses||0,c:C.red},{l:"LEVERAGE",v:"20x",c:C.yellow},{l:"SYMBOLS",v:12,c:C.text},{l:"STRATEGY",v:"ICT+BRK+OF",c:C.accent}].map(({l,v,c})=>(
          <div key={l} style={{display:"flex",gap:6,alignItems:"center"}}>
            <span style={{fontSize:8,color:C.textDim,letterSpacing:1,fontFamily:C.mono}}>{l}</span>
            <span style={{fontSize:8,color:c,fontFamily:C.mono,fontWeight:600}}>{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function TradesPage({trades}){
  const [filter,setFilter]=useState("ALL");const [search,setSearch]=useState("");
  const filtered=trades.filter(t=>{ if(filter==="WINS"&&(t.pnl||0)<=0)return false; if(filter==="LOSSES"&&(t.pnl||0)>0)return false; if(filter==="LONG"&&t.direction!=="LONG")return false; if(filter==="SHORT"&&t.direction!=="SHORT")return false; if(search&&!t.symbol?.toLowerCase().includes(search.toLowerCase()))return false; return true; });
  const totalPnl=filtered.reduce((a,b)=>a+(b.pnl||0),0);const wins=filtered.filter(t=>(t.pnl||0)>0).length;
  return(
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:C.bg2}}>
      <div style={{padding:"16px 24px",borderBottom:`1px solid ${C.border}`,background:C.bg,flexShrink:0}}>
        <div style={{fontSize:16,color:C.text,fontFamily:C.mono,fontWeight:700,letterSpacing:2,marginBottom:12}}>TRADE HISTORY</div>
        <div style={{display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search symbol..." style={{background:C.bg3,border:`1px solid ${C.border2}`,borderRadius:4,padding:"6px 12px",color:C.text,fontSize:11,fontFamily:C.mono,outline:"none",width:180}}/>
          <div style={{display:"flex",gap:4}}>
            {["ALL","WINS","LOSSES","LONG","SHORT"].map(f=>(
              <button key={f} onClick={()=>setFilter(f)} style={{padding:"5px 12px",background:filter===f?C.accent:"transparent",border:`1px solid ${filter===f?C.accent:C.border2}`,borderRadius:3,color:filter===f?"white":C.textMid,fontSize:9,fontFamily:C.mono,cursor:"pointer",letterSpacing:1}}>{f}</button>
            ))}
          </div>
          <div style={{marginLeft:"auto",display:"flex",gap:20}}>
            {[{l:"SHOWING",v:filtered.length,c:C.text},{l:"PNL",v:fmtMoney(totalPnl),c:pc(totalPnl)},{l:"WIN RATE",v:filtered.length?`${(wins/filtered.length*100).toFixed(1)}%`:"—",c:C.accent}].map(({l,v,c})=>(
              <div key={l} style={{textAlign:"right"}}><div style={{fontSize:8,color:C.textDim,letterSpacing:2,fontFamily:C.mono}}>{l}</div><div style={{fontSize:13,color:c,fontFamily:C.mono,fontWeight:600}}>{v}</div></div>
            ))}
          </div>
        </div>
      </div>
      <div style={{flex:1,overflowY:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead style={{position:"sticky",top:0,background:C.bg,zIndex:1}}>
            <tr style={{borderBottom:`1px solid ${C.border}`}}>{["#","SYMBOL","DIRECTION","ENTRY","EXIT","PNL","QTY","OPENED","CLOSED"].map(h=>(
              <th key={h} style={{fontSize:8,color:C.textDim,textAlign:"left",padding:"10px 16px",fontWeight:400,letterSpacing:2,fontFamily:C.mono,whiteSpace:"nowrap"}}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {filtered.map((t,i)=>(
              <tr key={i} style={{borderBottom:`1px solid ${C.border}08`,background:i%2===0?"transparent":C.bg+"80",transition:"background 0.1s"}} onMouseEnter={e=>e.currentTarget.style.background=C.accentGlow} onMouseLeave={e=>e.currentTarget.style.background=i%2===0?"transparent":C.bg+"80"}>
                <td style={{padding:"9px 16px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{filtered.length-i}</td>
                <td style={{padding:"9px 16px",color:C.text,fontFamily:C.mono,fontSize:11,fontWeight:600}}>{t.symbol}</td>
                <td style={{padding:"9px 16px"}}><span style={{fontSize:9,padding:"2px 8px",borderRadius:2,background:t.direction==="LONG"?C.greenGlow:C.redGlow,color:t.direction==="LONG"?C.green:C.red,border:`1px solid ${t.direction==="LONG"?C.green+"44":C.red+"44"}`,fontFamily:C.mono}}>{t.direction}</span></td>
                <td style={{padding:"9px 16px",color:C.textMid,fontFamily:C.mono,fontSize:10}}>{fmtPrice(t.entry)}</td>
                <td style={{padding:"9px 16px",color:C.textMid,fontFamily:C.mono,fontSize:10}}>{fmtPrice(t.exit)}</td>
                <td style={{padding:"9px 16px",fontFamily:C.mono,fontSize:11,fontWeight:700}}><span style={{color:pc(t.pnl),background:(t.pnl||0)>0?C.greenGlow:C.redGlow,padding:"2px 8px",borderRadius:2,border:`1px solid ${(t.pnl||0)>0?C.green+"44":C.red+"44"}`}}>{fmtMoney(t.pnl)}</span></td>
                <td style={{padding:"9px 16px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{t.qty?.toLocaleString()||"—"}</td>
                <td style={{padding:"9px 16px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{fmt(t.open_time)}</td>
                <td style={{padding:"9px 16px",color:C.textDim,fontFamily:C.mono,fontSize:10}}>{fmt(t.close_time)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length===0&&<div style={{textAlign:"center",padding:48,color:C.textDim,fontFamily:C.mono,fontSize:12}}>No trades found</div>}
      </div>
    </div>
  );
}

function AnalyticsPage({trades,stats,equityCurve,dailyPnl,symbolStats}){
  const closed=trades.filter(t=>t.pnl!=null);
  const wins=closed.filter(t=>t.pnl>0);const losses=closed.filter(t=>t.pnl<=0);
  const avgWin=wins.length?wins.reduce((a,b)=>a+b.pnl,0)/wins.length:0;
  const avgLoss=losses.length?losses.reduce((a,b)=>a+b.pnl,0)/losses.length:0;
  const profitFactor=losses.length&&Math.abs(avgLoss)>0?Math.abs(avgWin*wins.length/(avgLoss*losses.length)):0;
  const maxWin=wins.length?Math.max(...wins.map(t=>t.pnl)):0;
  const maxLoss=losses.length?Math.min(...losses.map(t=>t.pnl)):0;
  const sorted=symbolStats.slice().sort((a,b)=>b.pnl-a.pnl);
  const maxAbsPnl=Math.max(...sorted.map(s=>Math.abs(s.pnl)),1);
  const metrics=[
    {l:"TOTAL PNL",v:fmtMoney(stats.total_pnl),c:pc(stats.total_pnl||0)},
    {l:"WIN RATE",v:`${stats.win_rate||0}%`,c:C.accent},
    {l:"PROFIT FACTOR",v:profitFactor.toFixed(2),c:profitFactor>1?C.green:C.red},
    {l:"TOTAL TRADES",v:stats.total_trades||0,c:C.text},
    {l:"AVG WIN",v:fmtMoney(avgWin),c:C.green},
    {l:"AVG LOSS",v:fmtMoney(avgLoss),c:C.red},
    {l:"BEST TRADE",v:fmtMoney(maxWin),c:C.green},
    {l:"WORST TRADE",v:fmtMoney(maxLoss),c:C.red},
  ];
  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg2,padding:24}}>
      <div style={{fontSize:16,color:C.text,fontFamily:C.mono,fontWeight:700,letterSpacing:2,marginBottom:20}}>ANALYTICS</div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
        {metrics.map((m,i)=>(
          <div key={i} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:"14px 16px"}}>
            <div style={{fontSize:8,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:6}}>{m.l}</div>
            <div style={{fontSize:20,fontWeight:700,color:m.c,fontFamily:C.mono}}>{m.v}</div>
          </div>
        ))}
      </div>
      <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:"16px",marginBottom:24}}>
        <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:12}}>EQUITY CURVE — FULL HISTORY</div>
        <EqChart data={equityCurve} h={160} w={800} color={C.accent} id="eg2"/>
      </div>
      <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:"16px",marginBottom:24}}>
        <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:16}}>SYMBOL PERFORMANCE</div>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {sorted.map((s,i)=>{
            const barW=Math.abs(s.pnl)/maxAbsPnl*100;
            return(<div key={i} style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:80,fontSize:10,color:C.text,fontFamily:C.mono,flexShrink:0}}>{s.s.replace("USDT","")}</div>
              <div style={{flex:1,height:20,background:C.bg2,borderRadius:2,overflow:"hidden",position:"relative"}}>
                <div style={{position:"absolute",left:s.pnl>=0?0:"auto",right:s.pnl<0?0:"auto",width:`${barW}%`,height:"100%",background:s.pnl>=0?`${C.green}44`:`${C.red}44`,border:`1px solid ${s.pnl>=0?C.green:C.red}44`}}/>
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",padding:"0 8px",justifyContent:"space-between"}}>
                  <span style={{fontSize:9,color:pc(s.pnl),fontFamily:C.mono,fontWeight:600}}>{fmtMoney(s.pnl)}</span>
                  <span style={{fontSize:8,color:C.textDim,fontFamily:C.mono}}>{s.trades}t · {s.trades?((s.wins/s.trades)*100).toFixed(0):0}%WR</span>
                </div>
              </div>
            </div>);
          })}
          {sorted.length===0&&<div style={{textAlign:"center",padding:24,color:C.textDim,fontSize:11,fontFamily:C.mono}}>No trade data yet</div>}
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:"16px"}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:12}}>WIN/LOSS RATIO</div>
          <div style={{display:"flex",gap:4,height:32,borderRadius:4,overflow:"hidden",marginBottom:8}}>
            <div style={{flex:stats.wins||1,background:`${C.green}55`,border:`1px solid ${C.green}`,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:10,color:C.green,fontFamily:C.mono,fontWeight:700}}>{stats.wins||0}W</span></div>
            <div style={{flex:stats.losses||1,background:`${C.red}44`,border:`1px solid ${C.red}`,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:10,color:C.red,fontFamily:C.mono,fontWeight:700}}>{stats.losses||0}L</span></div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:C.textDim,fontFamily:C.mono}}>
            <span>WIN RATE: <b style={{color:C.green}}>{stats.win_rate||0}%</b></span>
            <span>TOTAL: <b style={{color:C.text}}>{stats.total_trades||0}</b></span>
          </div>
        </div>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:"16px"}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:12}}>EXPECTANCY PER TRADE</div>
          <div style={{fontSize:22,fontWeight:700,color:pc((avgWin*(stats.wins||0)+avgLoss*(stats.losses||0))/(stats.total_trades||1)),fontFamily:C.mono}}>
            {stats.total_trades?fmtMoney((avgWin*(stats.wins||0)+avgLoss*(stats.losses||0))/(stats.total_trades)):"—"}
          </div>
          <div style={{fontSize:9,color:C.textDim,fontFamily:C.mono,marginTop:4}}>average profit/loss per trade</div>
        </div>
      </div>
    </div>
  );
}

function LogsPage({logs}){
  const [filter,setFilter]=useState("ALL");const [search,setSearch]=useState("");
  const filterFns={ALL:()=>true,SIGNALS:l=>l.includes("SIGNAL")||l.includes("ORDER"),ERRORS:l=>l.includes("ERROR"),TRADES:l=>l.includes("tp_hit")||l.includes("sl_hit"),INFO:l=>l.includes("INFO")};
  const filtered=logs.filter(filterFns[filter]||filterFns.ALL).filter(l=>!search||l.toLowerCase().includes(search.toLowerCase()));
  const lc=l=>{ if(l.includes("ERROR"))return C.red; if(l.includes("tp_hit")||l.includes("✅"))return C.green; if(l.includes("SIGNAL")||l.includes("WARNING"))return C.yellow; if(l.includes("sl_hit"))return C.red; return C.textMid; };
  const lvl=l=>{ if(l.includes("ERROR"))return{t:"ERR",c:C.red,bg:C.redGlow}; if(l.includes("WARNING"))return{t:"WRN",c:C.yellow,bg:`${C.yellow}15`}; if(l.includes("SIGNAL")||l.includes("tp_hit")||l.includes("sl_hit"))return{t:"TRD",c:C.green,bg:C.greenGlow}; return{t:"INF",c:C.textDim,bg:"transparent"}; };
  return(
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:C.bg2}}>
      <div style={{padding:"16px 24px",borderBottom:`1px solid ${C.border}`,background:C.bg,flexShrink:0}}>
        <div style={{fontSize:16,color:C.text,fontFamily:C.mono,fontWeight:700,letterSpacing:2,marginBottom:12}}>SYSTEM LOGS</div>
        <div style={{display:"flex",gap:12,alignItems:"center"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search logs..." style={{background:C.bg3,border:`1px solid ${C.border2}`,borderRadius:4,padding:"6px 12px",color:C.text,fontSize:11,fontFamily:C.mono,outline:"none",width:220}}/>
          <div style={{display:"flex",gap:4}}>
            {Object.keys(filterFns).map(f=>(
              <button key={f} onClick={()=>setFilter(f)} style={{padding:"5px 12px",background:filter===f?C.accent:"transparent",border:`1px solid ${filter===f?C.accent:C.border2}`,borderRadius:3,color:filter===f?"white":C.textMid,fontSize:9,fontFamily:C.mono,cursor:"pointer",letterSpacing:1}}>{f}</button>
            ))}
          </div>
          <div style={{marginLeft:"auto",fontSize:9,color:C.textDim,fontFamily:C.mono}}>SHOWING {filtered.length} / {logs.length}</div>
        </div>
      </div>
      <div style={{flex:1,overflowY:"auto",fontFamily:C.mono}}>
        {filtered.slice().reverse().map((line,i)=>{ const lv=lvl(line);const parts=line.split("|"); return(
          <div key={i} style={{display:"flex",gap:0,borderBottom:`1px solid ${C.border}08`,fontSize:10,lineHeight:1.7,padding:"1px 0",transition:"background 0.1s"}} onMouseEnter={e=>e.currentTarget.style.background=C.bg} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{padding:"0 12px",color:C.textDim,flexShrink:0,minWidth:90,fontSize:9}}>{parts[0]?.trim().slice(0,19)}</div>
            <div style={{padding:"0 8px",display:"flex",alignItems:"center",flexShrink:0}}><span style={{fontSize:8,padding:"1px 5px",borderRadius:2,background:lv.bg,color:lv.c,letterSpacing:1,fontWeight:700}}>{lv.t}</span></div>
            <div style={{padding:"0 8px",color:C.textDim,flexShrink:0,minWidth:100,fontSize:9}}>{parts[2]?.trim().slice(0,16)}</div>
            <div style={{padding:"0 12px",color:lc(line),flex:1,wordBreak:"break-all"}}>{parts.slice(3).join("|").trim()}</div>
          </div>
        );})}
      </div>
    </div>
  );
}

function SettingsPage(){
  const [cfg,setCfg]=useState({symbols:[],winner_map:{},leverage:{default:20},risk_per_trade:0.04,max_positions:999,max_daily_loss:999,emergency_stop:999,cooldown_bars:16});
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    fetch(`${API}/api/config`,{headers:authHeader()}).then(r=>r.json()).then(d=>{setCfg(d);setLoading(false);}).catch(()=>setLoading(false));
  },[]);
  const WINNER_MAP=cfg.winner_map||{};
  const stratColors={ICT_Sensitive:C.accent,Breakout_Sensitive:C.green,Breakout_Main:C.yellow,OrderFlow_Aggressive:"#ff8800"};
  const grouped={};Object.entries(WINNER_MAP).forEach(([sym,strat])=>{if(!grouped[strat])grouped[strat]=[];grouped[strat].push(sym);});
  if(loading)return <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:C.bg2,color:C.textDim,fontFamily:C.mono,fontSize:11}}>Loading live config...</div>;
  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg2,padding:24}}>
      <div style={{fontSize:16,color:C.text,fontFamily:C.mono,fontWeight:700,letterSpacing:2,marginBottom:20}}>BOT SETTINGS</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:20}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:16}}>CONFIGURATION</div>
          {[
            {l:"Leverage",v:`${typeof cfg.leverage==="object"?cfg.leverage.default:cfg.leverage}x`,c:C.yellow},
            {l:"Risk per trade",v:`${((cfg.risk_per_trade||0.04)*100).toFixed(0)}%`,c:C.text},
            {l:"Max positions",v:`${cfg.max_positions>=999?"Unlimited":cfg.max_positions}`,c:C.text},
            {l:"Max daily loss",v:`${cfg.max_daily_loss>=999?"Disabled":cfg.max_daily_loss+"%"}`,c:C.green},
            {l:"Emergency stop",v:`${cfg.emergency_stop>=999?"Disabled":cfg.emergency_stop+"%"}`,c:C.green},
            {l:"Cooldown",v:`${cfg.cooldown_bars||16} bars (${cfg.cooldown_bars||16}h)`,c:C.text},
            {l:"Candle gate",v:"Last 5 min of hour",c:C.text},
            {l:"SL type",v:"ATR-based server-side",c:C.text},
            {l:"TP system",v:"TP1→Trail→TP2→Close",c:C.text},
            {l:"Exchange",v:"Bybit Futures",c:C.accent},
            {l:"Active symbols",v:(cfg.symbols||[]).length||Object.keys(WINNER_MAP).length,c:C.text},
            {l:"Base currency",v:"USDT",c:C.text},
          ].map(({l,v,c})=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`,fontSize:11,fontFamily:C.mono}}>
              <span style={{color:C.textMid}}>{l}</span><span style={{color:c,fontWeight:600}}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:20}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:16}}>WINNER MAP — ACTIVE STRATEGIES</div>
          {Object.entries(grouped).map(([strat,syms])=>(
            <div key={strat} style={{marginBottom:16}}>
              <div style={{fontSize:9,color:stratColors[strat]||C.text,fontFamily:C.mono,letterSpacing:1,marginBottom:8,display:"flex",alignItems:"center",gap:8}}><div style={{width:8,height:8,borderRadius:"50%",background:stratColors[strat]||C.text}}/>{strat}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {syms.map(sym=>(<div key={sym} style={{fontSize:9,padding:"3px 8px",background:`${stratColors[strat]}18`,border:`1px solid ${stratColors[strat]}44`,borderRadius:3,color:stratColors[strat]||C.text,fontFamily:C.mono}}>{sym.replace("USDT","")}</div>))}
              </div>
            </div>
          ))}
        </div>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:20}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:16}}>RISK MANAGEMENT</div>
          {[{l:"All risk halts",v:"DISABLED",c:C.green},{l:"Breakeven system",v:"DISABLED",c:C.green},{l:"Trailing stop",v:"ENABLED (0.5x SL)",c:C.green},{l:"TP flow",v:"TP1→Trail→TP2→Close",c:C.text},{l:"SL execution",v:"Server-side Bybit",c:C.text},{l:"Position sizing",v:"4% equity risk/trade",c:C.text},{l:"Margin cap",v:"20% equity max",c:C.text}].map(({l,v,c})=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`,fontSize:11,fontFamily:C.mono}}>
              <span style={{color:C.textMid}}>{l}</span><span style={{color:c,fontWeight:600}}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:6,padding:20}}>
          <div style={{fontSize:9,color:C.textDim,letterSpacing:2,fontFamily:C.mono,marginBottom:16}}>BACKTEST REFERENCE (12 SYMBOLS)</div>
          <table style={{width:"100%",borderCollapse:"collapse",fontFamily:C.mono}}>
            <thead><tr style={{borderBottom:`1px solid ${C.border}`}}>{["PERIOD","ROI","WIN RATE","MAX DD","SHARPE"].map(h=>(<th key={h} style={{fontSize:8,color:C.textDim,textAlign:"left",padding:"0 0 8px",fontWeight:400,letterSpacing:1}}>{h}</th>))}</tr></thead>
            <tbody>{[{p:"7d",roi:"+1.5%",wr:"33%",dd:"4.5%",sh:"2.3"},{p:"22d",roi:"+341%",wr:"52%",dd:"22%",sh:"8.6"},{p:"30d",roi:"+2024%",wr:"50%",dd:"31%",sh:"8.7"},{p:"60d",roi:"+7779%",wr:"44%",dd:"59%",sh:"7.0"},{p:"90d",roi:"+19408%",wr:"41%",dd:"61%",sh:"5.5"}].map(({p,roi,wr,dd,sh})=>(
              <tr key={p} style={{borderBottom:`1px solid ${C.border}`}}>
                <td style={{padding:"7px 0",color:C.textDim,fontSize:10}}>{p}</td>
                <td style={{padding:"7px 0",color:C.green,fontSize:10,fontWeight:600}}>{roi}</td>
                <td style={{padding:"7px 0",color:C.accent,fontSize:10}}>{wr}</td>
                <td style={{padding:"7px 0",color:C.red,fontSize:10}}>{dd}</td>
                <td style={{padding:"7px 0",color:C.yellow,fontSize:10}}>{sh}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



export default function App(){
  const [authed,setAuthed]=useState(!!localStorage.getItem("mb_token"));
  const [page,setPage]=useState("dashboard");
  const [data,setData]=useState({stats:{total_trades:0,total_pnl:0,wins:0,losses:0,win_rate:0},positions:[],trades:[],logs:[],status:{equity:0,uptime:"..."},btc:{price:0,change:0},equityCurve:[],dailyPnl:[],symbolStats:[]});

  const fetchAll=async()=>{
    try{
      const h=authHeader();
      const [bybit,pos,logs,status,btc]=await Promise.all([
        fetch(`${API}/api/bybit/trades`,{headers:h}).then(r=>r.json()),
        fetch(`${API}/api/bybit/positions`,{headers:h}).then(r=>r.json()),
        fetch(`${API}/api/logs?lines=200`,{headers:h}).then(r=>r.json()),
        fetch(`${API}/api/status`,{headers:h}).then(r=>r.json()),
        fetch(`${API}/api/btc`,{headers:h}).then(r=>r.json()),
      ]);
      if(bybit.detail==="Invalid token"){localStorage.removeItem("mb_token");setAuthed(false);return;}
      const trades=bybit.trades||[];
      let eq=110;const curve=[{t:"Start",v:110}];
      trades.filter(t=>t.pnl!=null).slice().reverse().forEach(t=>{eq+=t.pnl;curve.push({t:fmt(t.open_time).slice(0,5),v:parseFloat(eq.toFixed(2))});});
      if(status.equity)curve.push({t:"Now",v:parseFloat(status.equity.toFixed(2))});
      const days={};
      trades.filter(t=>t.pnl!=null).forEach(t=>{const d=fmt(t.open_time).slice(0,5);if(!days[d])days[d]=0;days[d]+=t.pnl;});
      const dailyPnl=Object.entries(days).slice(-7).map(([d,v])=>({d,v:parseFloat(v.toFixed(2))}));
      const syms={};
      trades.filter(t=>t.pnl!=null).forEach(t=>{if(!syms[t.symbol])syms[t.symbol]={s:t.symbol,pnl:0,trades:0,wins:0};syms[t.symbol].pnl+=t.pnl;syms[t.symbol].trades++;if(t.pnl>0)syms[t.symbol].wins++;});
      setData({stats:{total_trades:bybit.total_trades||0,total_pnl:bybit.total_pnl||0,wins:bybit.wins||0,losses:bybit.losses||0,win_rate:bybit.win_rate||0},positions:pos.positions||[],trades,logs:logs.logs||[],status,btc,equityCurve:curve,dailyPnl,symbolStats:Object.values(syms)});
    }catch(e){console.error(e);}
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{if(authed){fetchAll();const i=setInterval(fetchAll,10000);return()=>clearInterval(i);}},[authed]);

  const mobile=useMobile();
  if(!authed)return <Login onLogin={()=>setAuthed(true)}/>;
  if(mobile)return <MobileDashboard {...data} onLogout={()=>{localStorage.removeItem("mb_token");setAuthed(false);}}/>;
  return(
    <div style={{height:"100vh",display:"flex",flexDirection:"column",background:C.bg,color:C.text,fontFamily:C.sans,overflow:"hidden"}}>
      <Topbar status={data.status} btc={data.btc} stats={data.stats} onLogout={()=>{localStorage.removeItem("mb_token");setAuthed(false);}}/>
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>
        <Sidebar page={page} setPage={setPage} positions={data.positions}/>
        {page==="dashboard"&&<DashboardPage {...data}/>}
        {page==="trades"&&<TradesPage trades={data.trades}/>}
        {page==="analytics"&&<AnalyticsPage trades={data.trades} stats={data.stats} equityCurve={data.equityCurve} dailyPnl={data.dailyPnl} symbolStats={data.symbolStats}/>}
        {page==="logs"&&<LogsPage logs={data.logs}/>}
        {page==="settings"&&<SettingsPage/>}
      </div>
    </div>
  );
}
